export const DEFAULT_GOLD_PRICE = 63.89;
